import{makeAccessor}from"../core/index.js";export const skeletonShape=makeAccessor(["circle","rect"]);
//# sourceMappingURL=skeleton.props.js.map